import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as constants from "../../constants";

const deleteItemLogic = createLogic({
	type: ActionTypes.DELETE_ITEM,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		const { successCallback, errorCallback, itemName } = action;
		const message = itemName
			? `Are you sure you want to delete "${itemName}"`
			: "Are you sure you want to delete this item?";
		const result = window.confirm(message);
		if (result) {
			firebase
				.auth()
				.currentUser.getIdToken(true)
				.then(token => {
					const api = axios.create({
						baseURL: constants.BASE_API_URL,
						headers: { Authorization: "Bearer " + token },
					});
					api.delete(action.path)
						.then(data => {
							dispatch(successCallback(data));
							done();
						})
						.catch(error => {
							dispatch(errorCallback(error));
							done();
						});
				});
		}
	},
});

export default [deleteItemLogic];
